import FormField from '@las-drop-tools/el-form/FormField.jsx'

export default function Row({
    field: parentField,
    context
}){
    return <div key={parentField?.key} className="flex flex-row justify-between items-center space-x-4 w-full">
        {parentField.fields && parentField.fields.map((field)=> <FormField key={field.key} field={field} answers={context?.answers} setAnswers={context?.setAnswers} error={context?.error} />)}
    </div>
}